export class OrderStatusObject {
    public static INPROGRESS_STATUS = new OrderStatusObject("INPROGRESS", "access_time", "inprogress");
    public static CREATED_STATUS = new OrderStatusObject("CREATED", "star", "created");
    public static ACK_STATUS = new OrderStatusObject("ACK", "help", "");
    public static PENDING_STATUS = new OrderStatusObject("PENDING", "help", "pending");
    public static CANCELLING_STATUS = new OrderStatusObject("CANCELLING", "fast_rewind", "cancelling");
    public static CANCELLED_STATUS = new OrderStatusObject("CANCELLED", "skip_previous", "cancelled");
    public static HELD_STATUS = new OrderStatusObject("HELD", "warning", "held");
    public static COMPLETED_STATUS = new OrderStatusObject("COMPLETED", "done", "completed");
    public static PARTIAL_STATUS = new OrderStatusObject("PARTIAL", "help", "partial");
    public static SAVED_STATUS = new OrderStatusObject("SAVED", "bookmark", "saved");
    public static CANCELLING_HELD_STATUS = new OrderStatusObject("CANCELLING_HELD", "warning", "held");
    public static FAILED_STATUS = new OrderStatusObject("FAILED", "close", "failed");
    public static UNKNOWN_STATUS = new OrderStatusObject("UNKNOWN", "warning", "");

    constructor(public state: string, public icon: string, public cssClass: string) {
    }

    static create(): OrderStatusObject {
        return null;
    }

    static createWithStatus(status: string): OrderStatusObject {
        return this.getOrderStatus(status);
    }

    private static getOrderStatus(status: string): OrderStatusObject {
        let orderStatus: OrderStatusObject;
        switch (status) {
            case 'INPROGRESS':
                orderStatus = this.INPROGRESS_STATUS;
                break;
            case 'CREATED':
                orderStatus = this.CREATED_STATUS;
                break;
            case 'ACK':
                orderStatus = this.ACK_STATUS;
                break;
            case 'PENDING':
                orderStatus = this.PENDING_STATUS;
                break;
            case 'CANCELLING':
                orderStatus = this.CANCELLING_STATUS;
                break;
            case 'CANCELLED':
                orderStatus = this.CANCELLED_STATUS;
                break;
            case 'HELD':
                orderStatus = this.HELD_STATUS;
                break;
            case 'COMPLETED':
                orderStatus = this.COMPLETED_STATUS;
                break;
            case 'FAILED':
                orderStatus = this.FAILED_STATUS;
                break;
            case 'PARTIAL':
                orderStatus = this.PARTIAL_STATUS;
                break;
            case 'SAVED':
                orderStatus = this.SAVED_STATUS;
                break;
            case 'CANCELLING_HELD':
                orderStatus = this.CANCELLING_HELD_STATUS;
                break;
            default:
                orderStatus = this.UNKNOWN_STATUS;
                break;
        }
        return orderStatus;
    }

    public equals(status: OrderStatusObject): boolean {
        return this.state === status.state;
    }

}
